<div class="loader-wrapper">
    <div id="app-loader"></div>
</div>
